var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowSquareDownLeft = function SvgIconArrowSquareDownLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.125a1 1 0 0 1 1 1v2.086l3.543-3.543a1 1 0 1 1 1.414 1.414l-3.543 3.543h2.086a1 1 0 1 1 0 2H9.372a1 1 0 0 1-.702-.29l-.004-.005a1 1 0 0 1-.291-.705v-4.5a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 21.25a1.75 1.75 0 0 1-1.75-1.75v-15c0-.966.784-1.75 1.75-1.75h15c.966 0 1.75.784 1.75 1.75v15a1.75 1.75 0 0 1-1.75 1.75zm.25-2h14.5V4.75H4.75z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconArrowSquareDownLeft;